export default function Image({src,banner_img,alt}){
    return <img src={src} className={banner_img} alt={alt} />
}